// src/pages/Logout.jsx
import React, { Fragment, useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { useTranslation } from "react-i18next";
import { useAPI } from "../context/ApiContext";
import { SnackbarContext } from "../context/SnackbarContext";

const Logout = () => {
  const { t } = useTranslation();
  const api = useAPI();
  const { newSnack } = useContext(SnackbarContext);
  const history = useHistory();
  const [working, setWorking] = useState(false);

  const doLogout = async () => {
    if (working) return;
    setWorking(true);
    try {
      await api.logout();
      newSnack("success", t("LoggedOut") || "ログアウトしました");
      history.replace("/login");
    } catch {
      history.replace("/login");
    }
  };

  return (
    <Fragment>
      <Header />
      <Leftnav />

      <div className="main-content bg-lightblue theme-dark-bg right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                  <Link to="/settings" className="d-inline-block mt-2">
                    <i className="ti-arrow-left font-sm text-white"></i>
                  </Link>
                  <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                    {t("Logout101") || "ログアウト"}
                  </h4>
                </div>

                <div className="card-body p-lg-5 p-4 w-100 border-0 text-center">
                  <div className="font-xsss text-grey-700 mb-3">
                  {t("Logout102")}
                  </div>
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      className="btn bg-current text-white fw-700 font-xssss rounded-3 p-3 me-2"
                      onClick={doLogout}
                      disabled={working}
                    >
                      {working ? (t("Logout103") || "処理中…") : (t("Logout104"))}
                    </button>
                    <Link to="/settings" className="btn btn-outline-secondary fw-700 font-xssss rounded-3 p-3">
                    {t("Logout105")}
                    </Link>
                  </div>
                </div>
              </div>

              <div className="p-4 mb-3"></div>
            </div>
          </div>
        </div>
      </div>

      <Appfooter />
    </Fragment>
  );
};

export default Logout;
